module.exports = __webpack_public_path__ + "static/media/spinner.b8299dc0.svg";